import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// AIVIO timers: «Таймеры» (time-based rules), admin-only like the backend.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/timers'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_aivio_timers',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
